import { render, staticRenderFns } from "./orderSpInfo.vue?vue&type=template&id=62745ab0&scoped=true"
import script from "./orderSpInfo.vue?vue&type=script&lang=js"
export * from "./orderSpInfo.vue?vue&type=script&lang=js"
import style0 from "./orderSpInfo.vue?vue&type=style&index=0&id=62745ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62745ab0",
  null
  
)

export default component.exports